import React from "react"
import styled from "styled-components"
import { FormattedMessage } from "react-intl"
import { ChevronRight } from "react-feather"
import { Link } from "react-router-dom"
import { FadeInUp, FadeIn } from "animate-css-styled-components"
import Box from "../../lib/ui/ui-box"
import Media from "../../lib/theme/media"
import Text from "../text"
import Button from "../button"
import { getUserLanguage } from "../../utils/analytics"

const Background = styled(Box)`
  display: flex;
  min-height: 680px;
  width: 100%;
  justify-content: center;
  background-color: #fdfdff;
`

const Laptop = styled.img`
  max-width: 100%;
  margin-top: 30px;
  ${Media.small`
    max-width: 100%;   
    margin-top: 20px;
    margin-bottom: 93px;
  `};
`

export default props => {
  return (
    <Background>
      {/* Hero Wrapper */}
      <Box
        pt={[2, 10, 10]}
        mt={[0, 0, 10]}
        justify="space-between"
        align="center"
        flexDirection={["column", "column", "column"]}
        w={["80%", "80%", "80%", "991px"]}
      >
        <FadeIn duration="0.25s" delay="0.9s">
          <Box
            flexDirection={["column", "column", "row"]}
            align="flex-start"
            justify="center"
          >
            {/* First Column */}
            <Box
              flexDirection="column"
              pt={[5, 11]}
              pl={[0, 0, 0]}
              pr={[0, 0, 9]}
              justify="center"
              w={[1, 1, 1, 1]}
            >
              <Text
                fontSize={[1, 1, 2]}
                lineHeight={[1, 1, 2]}
                alignText={["center", "left"]}
                fontFamily="Libre Baskerville"
                fontWeight="400"
                color="actionPrimary"
                mt={[1]}
                mb={[3, 0, 0, 0]}
                w={[1, 1, 1, 1]}
              >
                <FormattedMessage
                  id="hero.footnote"
                  defaults="Through an equity release (commonly known as reverse  mortgage), you can turn  a portion of your home into a source of cash"
                />
              </Text>
              <Link
                to={`${props.intl.formatMessage({
                  id: "routes.reverse"
                })}/1`}
              >
                {/* Apply Button */}
                <Button
                  onClick={() =>
                    window.analytics.track("begin process", {
                      category: "reverse mortgage flow",
                      label: "APPLY",
                      location: "home",
                      language: getUserLanguage()
                    })
                  }
                  bg="actionPrimary"
                  mt={[3]}
                  pl={[1]}
                  pr={[1]}
                  size="fluid"
                  type="hero"
                  justify="space-between"
                >
                  <Text
                    fontFamily="Libre Baskerville"
                    fontWeight="400"
                    color="white"
                    fontSize={[2]}
                  >
                    <FormattedMessage id="hero.cta_new" defaults="APPLY" />
                  </Text>
                  <Text color="backgroundDarkBlue">
                    <ChevronRight size={36} color="white" />
                  </Text>
                </Button>
              </Link>
              <Link
                to={`${props.intl.formatMessage({
                  id: "routes.calculator"
                })}/1`}
              >
                <Button
                  onClick={() =>
                    window.analytics.track("begin process", {
                      category: "calculate amount",
                      label: "How much can i get?",
                      location: "home",
                      language: getUserLanguage()
                    })
                  }
                  bg="actionPrimary"
                  mt={[2]}
                  pl={[1]}
                  pr={[1]}
                  size="fluid"
                  type="hero"
                  justify="space-between"
                >
                  <Text
                    fontFamily="Libre Baskerville"
                    fontWeight="400"
                    color="white"
                    fontSize={[2]}
                  >
                    <FormattedMessage
                      id="hero.cta_renewal"
                      defaults="RENEWAL"
                    />
                  </Text>
                  <Text color="backgroundDarkBlue">
                    <ChevronRight size={36} color="white" />
                  </Text>
                </Button>
              </Link>
            </Box>
            {/* Second Column */}
            <Link to={props.intl.formatMessage({ id: "routes.get_quote" })}>
              <Box
                flexDirection="column"
                pt={[5, 5, 0]}
                style={{
                  maxWidth: "588px"
                }}
                align={["flex-start"]}
                w={[1, 1, 1, 1]}
              >
                {/* Texts */}
                <FadeInUp duration="0.3s" delay="0.3s">
                  {/* Small Text */}
                  <Text
                    style={{
                      margin: "0 auto"
                    }}
                    fontSize={[2, 2, 2, 3]}
                    fontFamily="Libre Baskerville"
                    fontWeight="400"
                    lineHeight={[2, 2, 2, 3]}
                    color="#2B3E51"
                    alignText={["center", "left"]}
                    w={["100%", "100%", "633px"]}
                  >
                    <FormattedMessage id="hero.subtitle" />
                  </Text>
                </FadeInUp>
                {!props.simple && (
                  <FadeInUp duration="0.3s" delay="0.5s">
                    {/* Big Text */}
                    <Text
                      fontSize={[3, 3, 4, 4]}
                      fontFamily="Libre Baskerville"
                      lineHeight={[3, 4, 5, 5]}
                      fontWeight="700"
                      color="#2B3E51"
                      alignText={["center", "left"]}
                      style={{
                        margin: "0 auto"
                      }}
                      w={["80%", 1, "80%", "633px"]}
                    >
                      <FormattedMessage id={props.heroCopy} />
                    </Text>
                  </FadeInUp>
                )}
              </Box>
              {/* Hero Image */}
              <Laptop
                onClick={() =>
                  window.analytics.track("Clicked CTA", {
                    location: "hero",
                    text: "Laptop Image",
                    type: "image"
                  })
                }
                src="/images/landing/hero.png"
                alt="Nesto Landing Page Image"
              />
            </Link>
          </Box>
        </FadeIn>
      </Box>
    </Background>
  )
}



// WEBPACK FOOTER //
// ./src/components/hero/hero.component.js